import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import TableBody from 'modules/_shared/Table/components/TableBody';

import EligiblesTableRow from './EligiblesTableRow';
import { Eligible } from '../types/Eligible';

type EligiblesTableBodyProps = {
  eligibles: Eligible[];
};

const EligiblesTableBody: FC<EligiblesTableBodyProps> = ({
  eligibles = [],
}) => {
  const { t } = useTranslate();

  const hasData = eligibles?.length > 0;

  const rows = eligibles!.map((eligible: any, index: number) => (
    <EligiblesTableRow
      // eslint-disable-next-line react/no-array-index-key
      key={`elegible-row-${index}`}
      index={index}
      eligible={eligible}
    />
  ));

  return (
    <TableBody
      hasData={hasData}
      content={rows}
      noDataColspan={14}
      noDataMessage={t('NoAvailableData')}
    />
  );
};

export default EligiblesTableBody;
